module.exports = __webpack_public_path__ + "img/Tablet - 32.12a04bd1.png";